export default __webpack_public_path__ + "static/media/laptop.9f39d499.png";